//--------------------------------------------
//
// Scene notifications
//
//--------------------------------------------

'use strict';

import q from 'q';
import moment from 'moment';
import PEOPLE from './People';
import TextExplode from './TextExplode';
import AudioManager from './AudioManager';
import RandomUser from './RandomUser';

const LIKE = 'img/icon_like.png';
const SAD = 'img/icon_sad.png';
const LOVE = 'img/icon_love.png';
const SURPRISE = 'img/icon_surprise.png';
const LAUGH = 'img/icon_laugh.png';
const MAD = 'img/icon_mad.png';

const ACTIONS = [
	{
		action: 'likes your post.',
		responses: [
			{
				text: 'Thanks!',
				emoji: LIKE

			},
			{
				text: 'Luv U!',
				emoji: LOVE
			},
			{
				text: 'Awesome',
				emoji: LAUGH
			},
			{
				text: 'Don’t Care!!',
				emoji: MAD
			}
		]
	},

	{
		action: 'invited you to an event.',
		responses: [
			{
				text: 'See U There!',
				emoji: LIKE
			},
			{
				text: 'NO WAY!!!!',
				emoji: MAD
			},
			{
				text: 'Not interested',
				emoji: SAD
			}
		]
	},

	{
		action: 'sent a friend request.',
		responses: [
			{
				text: 'Let’s connect!',
				emoji: LIKE
			},
			{
				text: 'Mute',
				emoji: SAD
			},
			{
				text: 'Ugh',
				emoji: MAD
			}
		]
	},

	{
		action: 'updated their profile.',
		responses: [
			{
				text: 'LIKE',
				emoji: LIKE
			},
			{
				text: 'Very Cool',
				emoji: LOVE
			},
			{
				text: 'Boring',
				emoji: LAUGH
			}
		]
	}
];


class Notifications {

	constructor(threeScene){
		const self = this;

		this.pos = 'top';
		this.header = document.getElementById('domScene');
		this.notifications = document.getElementsByClassName('notify');
		this.container = null;
		this.person = {};
		this.threeScene = threeScene;
		this.action = {};

		new RandomUser().then((user) => {
			self.person = user;
			self.init();
		});

		
	}


	init(){
		const self = this;

		

		this.action = ACTIONS[Math.floor(Math.random() * ACTIONS.length)];

		//--------------------------------------------
		// See if container is already present
		//
		if (this.notifications.length >= 1){
			this.pos = 'center';
		}

		if (this.notifications.length >= 2){
			this.pos = 'bottom';
		}


		this.container = document.createElement('div');
		this.container.classList.add('notify');
		this.container.classList.add('active');

		if (this.pos === 'top'){
			this.container.classList.add('top');
		}

		if (this.pos === 'center'){
			this.container.classList.add('center');
		}

		else if (this.pos === 'bottom'){
			this.container.classList.add('bottom');
		}

		this.header.appendChild(this.container);

		//--------------------------------------------
		// Create click target
		//
		const clickTarget = document.createElement('div');
		clickTarget.classList.add('target');
		this.container.appendChild(clickTarget);

		clickTarget.addEventListener('click', this.onClick.bind(this), false);


		//--------------------------------------------
		// Add image block
		//
		const imageBlock = document.createElement('div');
		imageBlock.classList.add('image-block');

		this.container.appendChild(imageBlock);


		//--------------------------------------------
		// Add image
		//
		const image = new Image();

		image.onload = () => {
			imageBlock.appendChild(image);
			self.continue();
		}

		image.src = this.person.picture.thumbnail;

	}

	continue(){
		//--------------------------------------------
		// Add text block
		//
		const textBlock = document.createElement('div');
		textBlock.classList.add('text-block');

		this.container.appendChild(textBlock);

		//--------------------------------------------
		// Add Name
		//
		const text = document.createElement('p');

		

		
		text.innerHTML = `<span>${this.person.name.first} ${this.person.name.last}</span> ${this.action.action}`;

		textBlock.appendChild(text);

		//--------------------------------------------
		// Add like icon + timestamp
		//
		const likeBlock = document.createElement('div');
		const likeImage = document.createElement('div');
		const likeText = document.createElement('div');
		
		likeBlock.classList.add('like-block');
		likeImage.classList.add('like-image');
		likeText.classList.add('like-text');

		likeText.textContent = `${moment().format('MMMM D')} at ${moment().format('h:mma')}`;

		textBlock.appendChild(likeBlock);

		likeBlock.appendChild(likeImage);
		likeBlock.appendChild(likeText);
	}

	

	onClick(ev){
		const self = this;
		
		//top item, but we have multiple notifications on screen
		if (this.container.classList.contains('top') && this.notifications.length > 1){
			this.notifications[this.notifications.length - 1].classList.remove('center');
			this.notifications[this.notifications.length - 1].classList.add('top');
		}

		//quit displaying item
		this.container.classList.add('gone');

		const appropriateResponse = this.action.responses[Math.floor(Math.random() * this.action.responses.length)]

		TextExplode(appropriateResponse.text);
		this.threeScene.addSprites(appropriateResponse.emoji);
		
		AudioManager.onNotificationClick();

		//completly remove item after hidden
		setTimeout(() => {
			self.container.remove();
		}, 100);
	}
}


export default Notifications;